/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import KeyPerson from "./keyPerson";
import AddClient from "./AddClient";
import OwnerDetails from "./OwnerDetails";
import ProjectMaster from "./ProjectMaster";
import Invoice from "./invoice";
import Policy from "./Policy";
import AnyPage from "./Application";

const clientMaster = {
  nameFirm: "",
  typeOfServices: "",
  gstNo: "",
  currentAccNo: 0,
  city: "",
  state: "",
  businessAdd: "",
  officeAdd: "",
  eleConnType: "",
  electricityConn: "",
  addCategory: "",
};
const MainContainer = () => {
  const [activeStep, setActiveStep] = useState(1);
  const [preId, setPreId] = useState("");
  const [clientPreId, setClientPreId] = useState("");
  const [ownerPreId, setOwnertPreId] = useState();
  const [invoicePreId, setInvoicePreId] = useState("");

  //Key Person
  const [keyPersonName, setKeyPersonName] = useState(null);

  //client Master
  const [clientMaterData, setClientMasterData] = useState(clientMaster);
  const [statusLoan, setStatusLoan] = useState("");
  const [firmType, setFirmType] = useState("");
  const [noOfEmploye, setNoOfEmploye] = useState(0);
  const [typeOfServices, setTypeOfServices] = useState("");
  const [eleConnType, setEleConnType] = useState("");
  const [addCategory, setAddCategory] = useState("");
  const [occupancyType, setOccupancyType] = useState("selfowned");
  const [sollarPower, setSollarPower] = useState(0);

  //Owner Details
  const clientId = localStorage.getItem("clientId");
  const [directors, setDirectors] = useState([
    {
      clientId: clientId,
      directorName: "",
      phoneNo: 0,
      dob: "",
      gender: "male",
      panNo: "",
      panImage: null,
      aadharNo: 0,
      aadharImage: null,
      category: "general",
      residenceAdd: "",
      physicallyHand: 0,
      authorized: 0,
    },
  ]);

  //Project master
  const [projectType, setProjectType] = useState("");
  const [noExp, setNoOfExpension] = useState();
  const [preProCost, setPreProjectCost] = useState();
  const [costProject, setCostProject] = useState();
  const [promoterCont, setPromoterCont] = useState();
  const [loanAmt, setLoanAmt] = useState();
  const [noMachine, setNoMachine] = useState();
  const [typeMachine, setTypeMachine] = useState([]);
  const [machineFrom, setMachineFrom] = useState("");
  const [proMachineType, setProMachineType] = useState([]);
  const [dateCom, setDateCom] = useState();
  const [loanSanction, setLoanSanction] = useState("");
  const [loanDisbursed, setLoanDisbursed] = useState("");
  const [rateInterest, setRateInterest] = useState();
  const [loanAcc, setLoanAcc] = useState();
  const [bankName, setBankName] = useState("");
  const [bankBranch, setBankBranch] = useState("");
  const [managerName, setManagerName] = useState("");
  const [managerMobile, setManagerMobile] = useState();
  const [cgtmseAns, setCgtmseAns] = useState("");
  const [cgPanNo, setCgPanNo] = useState("");
  const [cgCharges, setCgCharges] = useState();
  const [firstRegistration, setFirstRegistration] = useState();
  const [activity, setActivity] = useState([]);

  //Invoice
  const [files, setFiles] = useState({
    commercial_invoice: null,
    packing_list: null,
    bill_landing: null,
    certificate_origin: null,
    bill_entry: null,
    machine_payreceipt: null,
    transfer_receipt: null,
    tr6_challan: null,
    tax_invoice: null,
    payment_receipt: null,
    iem_registration: null,
    pan_card: null,
    partnership_deed: null,
    registration_firm: null,
    sale_rent_copy: null,
    audit_report: null,
    gst_Certificate: null,
    existing_list: null,
    vera_bill: null,
    digital_signature: null,
    gpcb_copy: null,
    cgtmse_letter: null,
    meter_sealing: null,
    project_completion: null,
    bank_appraisal: null,
  });

  //Apply
  const [physicalChecked, setPhysicalChecked] = useState(0);
  const [inWordNumber, setInWordNumber] = useState("");
  const [inWordIdDate, setInWordIdDate] = useState("");
  const [inWordIdFile, setInWordIdFile] = useState(null);
  const [onlineChecked, setOnlineChecked] = useState(0);
  const [appId, setAppId] = useState("");
  const [appIdDate, setAppIdDate] = useState("");
  const [appIdFile, setAppIdFile] = useState(null);
  const [password, setPassword] = useState("");
  const [userName, setUserName] = useState("");
  const [email, setEmail] = useState("");
  const [ePassword, setEPassword] = useState("")

  const steps = [
    { title: "Key person", className: "res-step-one" },
    { title: "Client", className: "res-step-two" },
    { title: "Owner", className: "res-step-three" },
    { title: "Project", className: "res-step-four" },
    { title: "Documents", className: "res-step-five" },
    { title: "Preview", className: "res-step-six" },
    { title: "Application", className: "res-step-seven" },
  ];

  const handleChangeClient = (e) => {
    setClientMasterData({
      ...clientMaterData,
      [e.target.name]: e.target.value,
    });
  };
  useEffect(() => {
    updateStepStyles(activeStep);
  }, [activeStep]);

  const updateStepStyles = (step) => {
    steps.forEach((stepClass, index) => {
      const element = document.querySelector(`.res-step-${index + 1}`);
      if (element) {
        const leftValue =
          index < step - 1 ? "150%" : index > step - 1 ? "-150%" : "0%";
        element.style.left = leftValue;
      }
    });
  };

  const handleNext = (id) => {
    const nextStep = activeStep + 1;
    if (nextStep <= steps.length) {
      setActiveStep(nextStep);
    }
  };

  const handleBack = () => {
    const prevStep = activeStep - 1;
    const projectId = localStorage.getItem("projectId");
    const clientId = localStorage.getItem("clientId");
    const ownerId = localStorage.getItem("OwnerId");
    const invoiceId = localStorage.getItem("documentId");
    if (prevStep >= 1) {
      setActiveStep(prevStep);
    }
    setPreId(projectId);
    setClientPreId(clientId);
    setOwnertPreId(JSON.parse(ownerId));
    setInvoicePreId(invoiceId);
  };

  const handleStepClick = (stepIndex) => {
    if (activeStep !== stepIndex + 1) {
      const projectId = localStorage.getItem("projectId");
      const clientId = localStorage.getItem("clientId");
      const ownerId = localStorage.getItem("OwnerId");
      const invoiceId = localStorage.getItem("documentId");

      setPreId(projectId || "");
      setClientPreId(clientId || "");
      setOwnertPreId(JSON.parse(ownerId));
      setInvoicePreId(invoiceId || "");
      setActiveStep(stepIndex + 1);
    }
  };

  useEffect(() => {
    if (
      ownerPreId?.length === 0 ||
      ownerPreId === undefined ||
      directors?.length === 0
    ) {
      setDirectors([
        {
          clientId: clientId,
          directorName: "",
          phoneNo: "",
          dob: "",
          gender: "male",
          panNo: "",
          panImage: null,
          aadharNo: "",
          aadharImage: null,
          category: "general",
          residenceAdd: "",
          physicallyHand: 0,
          authorized: 0,
        },
      ]);
    }
  }, [ownerPreId, clientId, directors?.length === 0]);

  return (
    <div id="main" className="main">
      <section id="form-post-new-job">
        <div className="res-steps-container">
          {steps.map((step, index) => (
            <div
              key={index}
              className={`res-steps ${step.className} ${
                activeStep === index + 1 ? "active" : ""
              }`}
              onClick={() => handleStepClick(index)}
            >
              <div className="res-step-bar">{step.title}</div>
              {/* <div className='res-step-title'>{step.title}</div> */}
              <div className="res-progress-bar"></div>
            </div>
          ))}
        </div>
      </section>

      <div>
        {activeStep === 1 && (
          <KeyPerson
            handleNext={handleNext}
            preId={preId}
            keyPersonName={keyPersonName}
            setKeyPersonName={setKeyPersonName}
          />
        )}
        {activeStep === 2 && (
          <AddClient
            handleBack={handleBack}
            clientPreId={clientPreId}
            handleNext={handleNext}
            clientMaterData={clientMaterData}
            setClientMasterData={setClientMasterData}
            handleChangeClient={handleChangeClient}
            statusLoan={statusLoan}
            setStatusLoan={setStatusLoan}
            firmType={firmType}
            setFirmType={setFirmType}
            noOfEmploye={noOfEmploye}
            setNoOfEmploye={setNoOfEmploye}
            typeOfServices={typeOfServices}
            setTypeOfServices={setTypeOfServices}
            eleConnType={eleConnType}
            setEleConnType={setEleConnType}
            addCategory={addCategory}
            setAddCategory={setAddCategory}
            occupancyType={occupancyType}
            setOccupancyType={setOccupancyType}
            sollarPower={sollarPower}
            setSollarPower={setSollarPower}
          />
        )}
        {activeStep === 3 && (
          <OwnerDetails
            activeStep={activeStep}
            handleBack={handleBack}
            ownerPreId={ownerPreId}
            handleNext={handleNext}
            directors={directors}
            setDirectors={setDirectors}
          />
        )}
        {activeStep === 4 && (
          <ProjectMaster
            addCategory={addCategory}
            handleBack={handleBack}
            preId={preId}
            handleNext={handleNext}
            projectType={projectType}
            setProjectType={setProjectType}
            noExp={noExp}
            setNoOfExpension={setNoOfExpension}
            preProCost={preProCost}
            setPreProjectCost={setPreProjectCost}
            costProject={costProject}
            setCostProject={setCostProject}
            promoterCont={promoterCont}
            setPromoterCont={setPromoterCont}
            loanAmt={loanAmt}
            setLoanAmt={setLoanAmt}
            noMachine={noMachine}
            setNoMachine={setNoMachine}
            typeMachine={typeMachine}
            setTypeMachine={setTypeMachine}
            machineFrom={machineFrom}
            setMachineFrom={setMachineFrom}
            proMachineType={proMachineType}
            setProMachineType={setProMachineType}
            dateCom={dateCom}
            setDateCom={setDateCom}
            loanSanction={loanSanction}
            setLoanSanction={setLoanSanction}
            loanDisbursed={loanDisbursed}
            setLoanDisbursed={setLoanDisbursed}
            rateInterest={rateInterest}
            setRateInterest={setRateInterest}
            loanAcc={loanAcc}
            setLoanAcc={setLoanAcc}
            bankName={bankName}
            setBankName={setBankName}
            bankBranch={bankBranch}
            setBankBranch={setBankBranch}
            managerName={managerName}
            setManagerName={setManagerName}
            managerMobile={managerMobile}
            setManagerMobile={setManagerMobile}
            cgtmseAns={cgtmseAns}
            setCgtmseAns={setCgtmseAns}
            cgPanNo={cgPanNo}
            setCgPanNo={setCgPanNo}
            cgCharges={cgCharges}
            setCgCharges={setCgCharges}
            firstRegistration ={firstRegistration}
            setFirstRegistration={setFirstRegistration}
            activity={activity}
            setActivity={setActivity}
          />
        )}
        {activeStep === 5 && (
          <Invoice
            cgtmseAns={cgtmseAns}
            sollarPower={sollarPower}
            handleBack={handleBack}
            invoicePreId={invoicePreId}
            handleNext={handleNext}
            files={files}
            setFiles={setFiles}
          />
        )}
        {activeStep === 6 && (
          <Policy addCategory={addCategory} costProject={costProject} handleBack={handleBack} handleNext={handleNext} />
        )}
        {activeStep === 7 && (
          <AnyPage
            handleBack={handleBack}
            physicalChecked={physicalChecked}
            setPhysicalChecked={setPhysicalChecked}
            inWordNumber={inWordNumber}
            setInWordNumber={setInWordNumber}
            inWordIdDate={inWordIdDate}
            setInWordIdDate={setInWordIdDate}
            inWordIdFile={inWordIdFile}
            setInWordIdFile={setInWordIdFile}
            onlineChecked={onlineChecked}
            setOnlineChecked={setOnlineChecked}
            appId={appId}
            setAppId={setAppId}
            appIdDate={appIdDate}
            setAppIdDate={setAppIdDate}
            appIdFile={appIdFile}
            setAppIdFile={setAppIdFile}
            password={password}
            setPassword={setPassword}
            userName={userName}
            setUserName={setUserName}
            email={email}
            setEmail={setEmail}
            ePassword={ePassword}
            setEPassword={setEPassword}
          />
        )}
      </div>
    </div>
  );
};

export default MainContainer;
